'use client'

import { Locale } from 'next-intl'

import { useTimer } from '../../lib/timer'

const formatTime = ({
  hours,
  minutes,
  seconds,
  locale = 'ko',
}: {
  hours: number
  minutes: number
  seconds: number
  locale?: Locale
}) => {
  if (locale === 'en') {
    return `${hours}h ${minutes}m ${seconds}s`
  }

  return `${hours}시간 ${minutes}분 ${seconds}초`
}

type Props = {
  deadline: string
  onEnd?: () => void
}

export const DeadlineTimer = ({ deadline, onEnd }: Props) => {
  const { timeLeft } = useTimer({
    time: deadline,
    onEnd,
    format: formatTime,
  })

  return <span className="font-semibold text-purple-500">{timeLeft}</span>
}
